import React from 'react';
import JetFontIcon, { JET_FONTICON_ALIASES } from "@src/shared/components/JetFontIcon"
import useStyles from './styles';



const OfflineMapIndicator = () => {
    const classes = useStyles();
    return <div className={classes.offlineMapView}>
      <div className={'overlay'}>
            <JetFontIcon className={'offlineWarningIcon'} iconname={JET_FONTICON_ALIASES.ALERT_TRIANGLE} size={43} />
      </div>
    </div>
}

export default OfflineMapIndicator